export default __webpack_public_path__ + "static/media/gb60_T.a53e04ca.jpg";